import { createContext } from 'react';

import { FinancialInfoProps } from 'components/modals/AssignmentDataModal/FinancialInfo';
import { JobCategoryEnum } from 'api/backofficeApiClient';

export type FinancialSchedulerType = Pick<
  FinancialInfoProps,
  | 'predefinedFinancialSchedulerValues'
  | 'workSiteWorkLocation'
  | 'w2InfoByWorkSiteWorkLocation'
> & {
  isW2Assignment?: boolean;
  isAdmin?: boolean;
  isViewDTBillRateDtPayRateFields?: boolean;
  jobCategory?: JobCategoryEnum | null;
};

const initialFinancialSchedulerContext: FinancialSchedulerType = {
  predefinedFinancialSchedulerValues: undefined,
  workSiteWorkLocation: null,
  w2InfoByWorkSiteWorkLocation: undefined,
  isW2Assignment: undefined,
  isAdmin: undefined,
  isViewDTBillRateDtPayRateFields: undefined,
  jobCategory: undefined,
};

const FinancialSchedulerContext = createContext(
  initialFinancialSchedulerContext,
);

export default FinancialSchedulerContext;
